<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete
            dense
            outlined
            v-model="viewValue"
            hide-details
            placeholder="Search..."
            :attach="false"
            :items="computedOptions"
            :search-input.sync="searchText"
        />
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    import axios from 'axios';
    import { debounce } from 'lodash';

    /**
     * Allows the selection of a personal details ID by choosing a name from
     * a selection downloaded from the API on search
     */
    export default {
        name: 'ies-personalDetailsKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                options: [],
				searchText: '',
                viewValue: parseInt(this.field.value),
            }
        },

        created() {
            this.debouncedGetOptions = debounce(this.getOptions, 400);
        },

        methods: {
            async getOptions() {
                let response = await axios.get('/api/selectable-personal-details', {
                    params: {
                        searchText: this.searchText || null,
                        personalDetailsKey: this.viewValue || null,
                    }
                });

                if (response.status == 200) {
                    this.options = response.data;

                    return response.data;
                }

                return [];
            },
        },

        watch: {
            viewValue() {
                this.field.value = this.viewValue;
            },
            searchText() {
                this.debouncedGetOptions();
            },
        },

        computed: {
            computedOptions(){
                let computedOptions = [];
                
                for (let i = 0; i < this.options.length; i++) {
                    let person = this.options[i];
                    let fullName = person.first_name + " " + person.last_name;
                    let email = person.email;
                       
                    let computedPerson = {
                        text: fullName + " (" + email + ")",
                        value: person.personal_details_key
                    };
                    computedOptions.push(computedPerson);
                }

                return computedOptions;
            }
        },

        mounted() {
            this.getOptions();
        }
    }
</script>
